// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__29aWm","label":"Completed_label__Io7pG"};